/* Navigation toggle */
var opener = $('#navOpen');
var closer = $('#navClose');
var parent = $('.navbar');
var html = $('html');
opener.on('click', function() {
  parent.addClass('navbar--active');
  html.addClass('overflow-hidden');
  setTimeout(function() {
    parent.addClass('navbar--after-transition');
  }, 700);
});
closer.on('click', function() {
  parent.removeClass('navbar--after-transition');
  parent.removeClass('navbar--active');
  html.removeClass('overflow-hidden');
});


//
// ─── LABEL - FOCUS ─────────────────────────────────────────────-
//
jQuery(document).on('nfFormReady', function() {
  $('.ninja-forms-field').focus(function () {
    $("label[for='" + this.id + "']").addClass('focused-label');
  });
  $('.ninja-forms-field').focusout(function () {
    if ($(this).val().length == 0) {
      $("label[for='" + this.id + "']").removeClass('focused-label');
    }
  });
});


//
// ─── HEADER - PARALLAX ─────────────────────────────────────────────-
//
$('.header--home').parallaxie({
  speed: 0.5
});


//
// ── YOUTUBE - PLAYER ─────────────────────────────────────────────
//
var youtube = document.querySelectorAll( ".youtube" );
for (var i = 0; i < youtube.length; i++) {
  var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.embed +"/maxresdefault.jpg";
  var image = new Image();
  image.src = source;
  image.addEventListener( "load", function() {
    youtube[ i ].appendChild( image );
  }( i ) );
  youtube[i].addEventListener( "click", function() {
    var iframe = document.createElement( "iframe" );
    iframe.setAttribute( "frameborder", "0" );
    iframe.setAttribute( "allowfullscreen", "" );
    iframe.setAttribute( "autoplay", "1" );
    iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );
    this.innerHTML = "";
    this.appendChild( iframe );
    this.classList.add('youtube--active');
  });
}

//
// ── OBSERVER - HEADING BLOCK ─────────────────────────────────────────────
//
var headingBlocks = $('.heading__block');

if (!('IntersectionObserver' in window)) {
  headingBlocks.each(function(i) {
    this.classList.add('heading__block--active');
  });
} else {
  observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.intersectionRatio > 0) {
        entry.target.classList.add('heading__block--active');
        observer.unobserve(entry.target);
      }
    })
  }, {
    rootMargin: '-100px 0px'
  });

  headingBlocks.each(function(){
    observer.observe(this);
  })
}


//
// ── SINGLE PRODUCT - ACCORDION ─────────────────────────────────────────────
//
(function($) {

  var allPanels = $('.accordion .accordion__description');
  var allBlocks = $('.accordion .accordion__block');
  allPanels.slice(1).hide();

  $('.accordion .accordion__title').click(function() {
    $this = $(this);
    $block =  $this.parent();
    $desc = $this.next();

    if(!$block.hasClass('active')){
      allPanels.slideUp(300);
      allBlocks.removeClass('active');
      $block.addClass('active');
      $desc.slideDown(300);
    }

    return false;
  });

})(jQuery);